<template>
  <div id="dashboard" class="dashboard"></div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import firebase from 'firebase/app';
import db from '../firebaseInit';
import checkIfPersonalBestDocExists from './../helpers/checkIfPersonalBestDocExists';
import createPersonalBestDoc from './../helpers/createPersonalBestDoc';
import updatePersonalBestDoc from './../helpers/updatePersonalBestDoc';

const userVuexModule = createNamespacedHelpers('userVuexModule');

export default {
  name: 'Dashboard',
  title: 'Dashboard',
  data() {
    return {
      firstName: '',
    };
  },
  created() {
    this.firstName = this.getFirstName;
  },
  methods: {},
  computed: {
    ...userVuexModule.mapGetters(['getFirstName']),
  },
};
</script>

<style lang="scss" scoped></style>
